import { memo, ReactNode } from 'react'
// Reward type icons
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import LightbulbIcon from '@mui/icons-material/Lightbulb'
import HeadphonesIcon from '@mui/icons-material/Headphones'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import ImageIcon from '@mui/icons-material/Image'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import TimerIcon from '@mui/icons-material/Timer'
import ArticleIcon from '@mui/icons-material/Article'
import GroupIcon from '@mui/icons-material/Group'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'
import { WorkflowNodeType } from '@features/adventures/types/workflow.types'

// Map node types to their icons and labels
const rewardNodeConfig: Record<number, { icon: ReactNode; label: string }> = {
  [WorkflowNodeType.PoiLocation]: { icon: <LocationOnIcon fontSize="small" />, label: 'Location' },
  [WorkflowNodeType.TextClue]: { icon: <LightbulbIcon fontSize="small" />, label: 'Clue Gate' },
  [WorkflowNodeType.AudioPlayer]: { icon: <HeadphonesIcon fontSize="small" />, label: 'Audio Player' },
  [WorkflowNodeType.VideoPlayer]: { icon: <VideoLibraryIcon fontSize="small" />, label: 'Video Player' },
  [WorkflowNodeType.ImageDisplay]: { icon: <ImageIcon fontSize="small" />, label: 'Image Display' },
  [WorkflowNodeType.UnlockAdventure]: { icon: <LockOpenIcon fontSize="small" />, label: 'Unlock Adventure' },
  [WorkflowNodeType.TimeModifier]: { icon: <TimerIcon fontSize="small" />, label: 'Time Bonus/Penalty' },
  [WorkflowNodeType.FormattedMessage]: { icon: <ArticleIcon fontSize="small" />, label: 'Formatted Message' },
  [WorkflowNodeType.GroupMembership]: { icon: <GroupIcon fontSize="small" />, label: 'Group Membership' },
  [WorkflowNodeType.GiftReward]: { icon: <CardGiftcardIcon fontSize="small" />, label: 'Gift Reward' },
}

// Default icon and label for unknown reward types
const defaultRewardConfig = { icon: <EmojiEventsIcon fontSize="small" />, label: 'Reward' }

interface RewardNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

/**
 * RewardNode - Handles all reward node types
 * - PoiLocation (nodeType: 20)
 * - TextClue (nodeType: 21)
 * - AudioPlayer (nodeType: 22)
 * - VideoPlayer (nodeType: 23)
 * - ImageDisplay (nodeType: 24)
 * - UnlockAdventure (nodeType: 25)
 * - TimeModifier (nodeType: 26)
 * - FormattedMessage (nodeType: 27)
 * - GroupMembership (nodeType: 28)
 * - GiftReward (nodeType: 29)
 */
function RewardNode(props: RewardNodeProps) {
  const { data } = props
  const { nodeType } = data

  // Get config for this node type
  const config = rewardNodeConfig[nodeType] || defaultRewardConfig

  return (
    <BaseNode
      {...props}
      icon={config.icon}
      headerLabel={config.label}
      showTargetHandle={true}
      showSourceHandle={true}
    />
  )
}

export default memo(RewardNode)
